// Central donation / community links.
// Monobase has two tabs: recurring subscription (powers levels & points) and one-time donation.
export const SUBSCRIBE_URL = "https://base.monobank.ua/vprytul#subscriptions"; // recurring subscription
export const DONATE_URL = "https://base.monobank.ua/vprytul#donate";           // one-time donation
// TODO: replace with the subscribers-only Telegram channel link when available.
export const COMMUNITY_URL = "https://t.me/prytulafoundation";
